import { Title } from '../../utils/title';
import Layout from './Layout';
import styles from './Privacy.module.scss';

const Campaign = () => {
  return (
    <Layout>
      <div className={styles.root}>

        <Title value='General Campaign Terms and Conditions' />

        {
          /*
           * BEGIN HTML
           */
        }
        <div className="d-flex justify-content-center align-items-center text-black">
          <h2 className="card-title text-muted text-black">
            GENERAL CAMPAIGN TERMS AND CONDITIONS
          </h2>
        </div>

        <h4 className="card-subtitle mb-2 text-muted text-black">DEFINITIONS</h4>
        <p className="card-text font-weight-bold text-black">
          <ul>
            <li>"Agreement" refers to this General Campaign Terms and Conditions document and any amendments thereto.</li>
            <li>"Brand" refers to any third-party company whose products may be featured in the Campaign.</li>
            <li>"Campaign" refers to the Company's marketing initiative as outlined in the campaign brief provided to the Creator.</li>
            <li>"Company" refers to Chimeable Inc.</li>
            <li>"Content" refers to all materials created by the Creator in connection with this Agreement, including videos, photographs, text, and audio.</li>
            <li>"Creator" refers to the individual entering into this Agreement to create and publish Content.</li>
            <li>"Deliverables" refers to the specific Content and services the Creator agrees to provide under this Agreement.</li>
          </ul>
        </p>

        <h4 className="card-subtitle mb-2 text-muted text-black">PURPOSE OF THE AGREEMENT</h4>
        <p className="card-text font-weight-bold text-black">
          The Company facilitates partnerships between brands and creators. The Company is conducting this Campaign and would like the Creator's assistance in creating Content featuring products provided by the Company. The Company hereby appoints the Creator, on a non-employee basis, to create and publish Content as specified in this Agreement.
        </p>

        <h4 className="card-subtitle mb-2 text-muted text-black">ACKNOWLEDGMENT</h4>
        <p className="card-text font-weight-bold">
          The Company and the Creator acknowledge the terms of this Agreement and will comply.
        </p>

        <h4 className="card-subtitle mb-2 text-muted text-black">DELIVERABLES</h4>
        <p className="card-text font-weight-bold">
          The Creator will deliver the agreed number of posts and creatives on the agreed platforms according to the delivery schedule specified by the Company.
          <ul>
            <li>The Creator agrees to write an honest text review on the retailer website specified by the Company.</li>
            <li>Provide Chimeable Inc. with a raw video featuring the product.</li>
            <li>The Creator agrees to post the final Content on their social media account.</li>
            <li>
              The Creator agrees to follow the Text Review Content guidelines:
              <ul>
                <li>Disclose that they received the product for free</li>
              </ul>
            </li>
            <li>The Creator agrees to only use royalty-free or copyright-free music in all Content. The Creator is solely responsible for ensuring proper licensing of any music used and shall indemnify the Company against any claims arising from music licensing violations.</li>
          </ul>
        </p>

        <h4 className="card-subtitle mb-2 text-muted text-black">TERM</h4>
        <p className="card-text font-weight-bold">
          The term of this Agreement shall commence on the effective date of this Agreement. Services described above should be completed within 14 days of receiving products. Beyond the one TikTok post on a public account, the Creator is free to publish any additional Content featuring the products, with respect to any applicable intellectual property rights.
        </p>

        <h4 className="card-subtitle mb-2 text-muted text-black">COPYRIGHT</h4>
        <p className="card-text font-weight-bold">
          The Creator agrees to irrevocably assign all rights, title, and interest in the Content created under this Agreement to Chimeable Inc. in perpetuity and on a worldwide basis. This assignment includes all copyrights, neighboring rights, and any other intellectual property rights in the Content, in all formats and media now known or hereafter developed. Chimeable Inc. may transfer or license these rights to third parties for use across all marketing outlets, including paid media and organic social content. The Creator waives any moral rights to the extent permitted by law.
        </p>

        <h4 className="card-subtitle mb-2 text-muted text-black">NON-SOLICITATION</h4>
        <p className="card-text font-weight-bold">
          During this Campaign, as well as for a 12-month period following the end of the current Campaign, the Creator shall not directly or indirectly contact, solicit, or engage with any third party featured in the Campaign for any commercial purpose without the Company's explicit written consent.
        </p>

        <h4 className="card-subtitle mb-2 text-muted text-black">CONFIDENTIALITY</h4>
        <p className="card-text font-weight-bold">
          During this Campaign, as well as for a 12-month period following the end of the current Campaign, the Creator shall keep confidential all non-public information related to this Agreement, including but not limited to: compensation terms, unreleased product information, campaign strategies, and any proprietary information shared by the Company. The Creator shall not disclose such information to any third party without the Company's prior written consent.
        </p>

        <h4 className="card-subtitle mb-2 text-muted text-black">INDEMNIFICATION</h4>
        <p className="card-text font-weight-bold">
          The Creator agrees to indemnify, defend, and hold harmless the Company and its officers, directors, employees, agents, and affiliates from and against any and all claims, damages, losses, liabilities, costs, and expenses (including reasonable attorneys' fees) arising out of or related to: (a) any breach of this Agreement by the Creator; (b) the Creator's Content, including but not limited to claims of intellectual property infringement, defamation, or violation of any third-party rights; (c) any misrepresentation made by the Creator; or (d) any violation of applicable laws or regulations by the Creator in connection with this Agreement.
        </p>

        <h4 className="card-subtitle mb-2 text-muted text-black">LIMITATION OF LIABILITY</h4>
        <p className="card-text font-weight-bold">
          To the maximum extent permitted by applicable law, the Company shall not be liable to the Creator for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, revenue, data, or business opportunities, arising out of or related to this Agreement, regardless of whether such damages were foreseeable or whether the Company was advised of the possibility of such damages. The Company's total cumulative liability under this Agreement shall not exceed the total compensation paid or payable to the Creator under this Agreement, or the retail value of any products provided to the Creator, whichever is greater.
        </p>
        <p className="card-text font-weight-bold">
          The Company shall not be liable for any failure, delay, or inability to deliver products to the Creator for any reason whatsoever. The Creator acknowledges that product delivery is not guaranteed and that the Company is under no obligation to replace, reship, or provide monetary compensation for any products that fail to reach the Creator.
        </p>

        <h4 className="card-subtitle mb-2 text-muted text-black">DISPUTE RESOLUTION</h4>
        <p className="card-text font-weight-bold">
          Any dispute, controversy, or claim arising out of or relating to this Agreement shall first be attempted to be resolved through good faith negotiation between the parties for a period of thirty (30) days. If the dispute cannot be resolved through negotiation, the parties agree to submit the dispute to binding arbitration administered by the American Arbitration Association in accordance with its Commercial Arbitration Rules. The arbitration shall take place in New York, New York, and shall be conducted by a single arbitrator. The decision of the arbitrator shall be final and binding on both parties, and judgment upon the award may be entered in any court of competent jurisdiction. Each party shall bear its own costs and attorneys' fees, unless the arbitrator determines otherwise.
        </p>

        <h4 className="card-subtitle mb-2 text-muted text-black">AMENDMENT</h4>
        <p className="card-text font-weight-bold">
          This Agreement can only be changed or modified through the written consent of both parties (Company and Creator).
        </p>

        <h4 className="card-subtitle mb-2 text-muted text-black">GOVERNING LAW</h4>
        <p className="card-text font-weight-bold">
          This Agreement shall be governed by and construed according to the laws of the State of New York.
        </p>
        {
          /*
           * END HTML
           */
        }

      </div>
    </Layout>
  );
};

export default Campaign;